import { forwardRef, useImperativeHandle } from 'react';

import { useModalDialog } from '@xemplo/modal-dialog';
import { useDeletePayrunApprovers } from '@xemplo/payrun-query';
import { ToastType, useToast } from '@xemplo/toast';

import { PayrunApprovalDetailModal } from './modal/payrun-approvers-detail-modal';
import {
  ModalDialogRef,
  PayrunApproversDetailProps,
} from './payrun-approvers-detail.types';

export const PayrunApproversDetail = forwardRef<
  ModalDialogRef,
  PayrunApproversDetailProps
>((props: PayrunApproversDetailProps, ref) => {
  const { companyId, userId, name, profilePhoto } = props;

  const modalDialog = useModalDialog({
    id: 'payrun-approver-detail-modal',
  });

  const { addToast } = useToast();

  const { mutateAsync: deleteApprover } = useDeletePayrunApprovers({
    onSuccess: () => {
      addToast({
        text: 'Approver removed',
        type: ToastType.Confirmation,
      });

      modalDialog.closeDialog();
    },
    onError: (error) => {
      const errorMessage = error.message ?? 'Something went wrong, please try again.';
      addToast({
        text: errorMessage,
        type: ToastType.Alert,
      });
      modalDialog.closeDialog();
    },
  });

  const deletePayRunApprover = async () => {
    await deleteApprover({
      companyId,
      userId,
    });
  };

  useImperativeHandle(ref, () => modalDialog);

  return (
    <PayrunApprovalDetailModal
      {...modalDialog}
      onDelete={deletePayRunApprover}
      companyId={companyId}
      userId={userId}
      name={name}
      profilePhoto={profilePhoto}
    />
  );
});
